document.addEventListener("DOMContentLoaded", function() {
    const forms = document.getElementsByTagName('form');

    Object.keys(forms).forEach((key) => {
        forms[key].addEventListener('click', () => {
            setCustomValidityMessages(forms[key]);
        });
    });
});

const setCustomValidityMessages = (form) => {
    if (form.classList.contains('custom-validity-messages-set')) {
        return;
    }

    const elements = document.getElementsByTagName('input');

    Object.keys(elements).forEach((key) => {
        setCustomValidityMessage(elements[key]);
    });

    form.classList.add('custom-validity-messages-set');
};

const setCustomValidityMessage = (element) => {
    if (element.oninvalid !== null) {
        return;
    }

    element.oninvalid = function(e) {
        e.target.setCustomValidity("");
        if (!e.target.validity.valid) {
            e.target.setCustomValidity("Vul alsjeblieft het verplichte veld in");
        }
    };
    element.oninput = function(e) {
        e.target.setCustomValidity("");
    };
};


// WEBPACK FOOTER //
// ./scripts/custom/custom-validity.js